const HOME = '/icons/tutoring-institute/home.svg';
const STAR = '/icons/tutoring-institute/star.svg';
const SEARCH = '/icons/tutoring-institute/search.svg';
const EYE = '/icons/tutoring-institute/eye.svg';
const EDIT = '/icons/tutoring-institute/edit.svg';
const DELETE = '/icons/tutoring-institute/delete.svg';

export { HOME, STAR, SEARCH, EYE, EDIT, DELETE };
